import { useEffect, useMemo, useState } from 'react';
import type { Socket } from 'socket.io-client';
import { SocketNamespace } from '@trinity/chat';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useMessageTestingSocket = (runId?: number): Socket | undefined => {
  const [socket, setSocket] = useState<Socket | undefined>();
  const getSocket = useGetSocket(SocketNamespace.MessageTesting);

  const logger = useMemo(() => createLogger({ namespace: SocketNamespace.MessageTesting }), []);

  useEffect(() => {
    if (runId != null) {
      logger.log(`Setting up socket for message-testing run: ${runId}`);
      const newSocket = getSocket();
      setSocket(newSocket);

      const handleConnect = () => {
        logger.log(`Socket connected, subscribing to: ${runId}`);
        newSocket.emit('subscribe', runId);
      };

      if (newSocket.connected) {
        handleConnect();
      } else {
        newSocket.on('connect', handleConnect);
      }

      return () => {
        logger.log(`Cleaning up socket for message-testing run: ${runId}`);
        newSocket.off('connect', handleConnect);
        newSocket.emit('unsubscribe', runId);
        newSocket.disconnect();
      };
    }
  }, [getSocket, logger, runId]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.MessageTesting);

  return socket;
};
